import { mockSuccess, listPayload } from './shared';
import type { MockRouteEntry } from '../mock-api.types';

const ROWS = [
    { id: 'mock-1', title: 'Warning letter — J. Doe', status: 'draft', updated_at: '2026-06-04T12:00:00Z' },
    { id: 'mock-2', title: 'Increment letter — A. Smith', status: 'draft', updated_at: '2026-06-04T12:00:00Z' },
    { id: 'mock-3', title: 'HR memo — onboarding', status: 'draft', updated_at: '2026-06-04T12:00:00Z' },
];

export const HRM_MOCK_HANDLERS: MockRouteEntry[] = [
    {
        method: 'GET',
        pattern: /\/api\/[^/]+\/[^/]+\/hrm\/letters(\?|$)/i,
        handler: () => mockSuccess(listPayload(ROWS)),
    },
    {
        method: 'GET',
        pattern: /\/api\/[^/]+\/[^/]+\/hrm\/letters\/([^/?]+)/i,
        handler: (req) => {
            const match = req.url.match(/\/letters\/([^/?]+)/i);
            const id = match ? match[1] : '';
            const row = ROWS.find((r) => r.id === id) ?? ROWS[0];
            return mockSuccess(row);
        },
    },
];
